import React from 'react'
import styled from 'styled-components'
import LoadingDots from '../../atoms/LoadingDots'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: 600px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.7);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`
const LoadingOverlay = () => {
  return (
    <Overlay>
      <LoadingDots/>
    </Overlay>
  )
}

export default LoadingOverlay
